import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Rule } from '../models/rule.model';
import { RuleConfigFilterViewModel } from '../models/rule-config-filter-view.model';
import { ApiResponse } from '../../shared/models/api-response.model';
import { RuleParameterMapping } from '../models/rule-parameter-mapping.model';
import { Employee } from '../models/employee';
import { MirrorRuleVM } from '../models/mirror-rule';
import { RuleFilters } from '../models/rule-filters';
import { Platform } from '../models/platform';


const apiRoot = '/api/settings';

@Injectable()
export class SettingsService {
  public constructor(private http: HttpClient) { }

  public getRuleApps(): Observable<Rule[]> {
    return this.http.get<Rule[]>(`${apiRoot}/GetRuleApps`);
  }

  public getEmployees(): Observable<Employee[]> {
    return this.http.get<Employee[]>(`${apiRoot}/GetEmployees`);
  }

  public getCurrentEmployee(): Observable<Employee> {
    return this.http.get<Employee>(`${apiRoot}/GetCurrentEmployee`);
  }

  public getEmployeeTeamPlatforms(employeeId: number): Observable<Platform[]> {
    return this.http.get<Platform[]>(`${apiRoot}/GetEmployeeTeamPlatforms?employeeId=${employeeId}`);
  }

  public getRuleParameterMappings(userId?: number, appShortName?: string | null, platformId?: number, isAdmin?: boolean): Observable<RuleParameterMapping[]> {
    if (appShortName) {
      return this.http.get<RuleParameterMapping[]>(`${apiRoot}/GetRuleParameterMappings?appShortName=${appShortName}`);
    }
    return this.http.get<RuleParameterMapping[]>(`${apiRoot}/GetAllRuleParameterMappings?userId=${userId}&platformId=${platformId}&isAdmin=${isAdmin}`);
  }

  public getRuleConfigs(ruleFilters: RuleFilters): Observable<RuleConfigFilterViewModel> {
    return this.http.post<RuleConfigFilterViewModel>(`${apiRoot}/GetRuleConfigs`, ruleFilters);
  }

  public GetUserConfiguredRules(userId: number): Observable<Rule[]> {
    return this.http.get<Rule[]>(`${apiRoot}/GetUserConfiguredRules?userId=${userId}`);
  }

  public save(ruleConfigs: RuleConfigFilterViewModel): Observable<any> {
    return this.http.post<any>(`${apiRoot}/SaveRuleConfigs`, ruleConfigs);
  }

  public resetAndSave(ruleConfigs: RuleConfigFilterViewModel): Observable<any> {
    return this.http.post<any>(`${apiRoot}/AddRuleConfigs`, ruleConfigs);
  }

  public saveWithParent(ruleConfigs: RuleConfigFilterViewModel): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${apiRoot}/SaveRuleConfigsWithparent`, ruleConfigs);
  }

  public mirrorUserConfigs(mirrorRuleVM: MirrorRuleVM): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${apiRoot}/MirrorUserConfigs`, mirrorRuleVM);
  }
}
